<div class="evaluation-mysupport-container" *ngIf="!isLoadingLabels && !isLoadingEvaluation">
	<div class="titles">{{ labels.lbl_geral_pesquisa_satisfacao }}</div>
	<section class="section-one">
		<div>
			<ul>
				<li>
					<div *ngIf="accessCmdb" class="classification-categories">
						<span>{{ labels.lbl_cmdb }}</span>
						<div class="classification-categorie">
							<input type="radio" id="cmdb-5" name="cmdb-rating" value="5" (change)="valueCmdb = 5" />
							<label for="cmdb-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cmdb-4" name="cmdb-rating" value="4" (change)="valueCmdb = 4" />
							<label for="cmdb-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cmdb-3" name="cmdb-rating" value="3" (change)="valueCmdb = 3" />
							<label for="cmdb-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cmdb-2" name="cmdb-rating" value="2" (change)="valueCmdb = 2" />
							<label for="cmdb-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cmdb-1" name="cmdb-rating" value="1" (change)="valueCmdb = 1" />
							<label for="cmdb-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
					<div *ngIf="accessCockpit" class="classification-categories">
						<span>Cockpit</span>
						<div class="classification-categorie">
							<input type="radio" id="cockpit-5" name="cockpit-rating" value="5" (change)="valueCockpit = 5" />
							<label for="cockpit-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cockpit-4" name="cockpit-rating" value="4" (change)="valueCockpit = 4" />
							<label for="cockpit-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cockpit-3" name="cockpit-rating" value="3" (change)="valueCockpit = 3" />
							<label for="cockpit-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cockpit-2" name="cockpit-rating" value="2" (change)="valueCockpit = 2" />
							<label for="cockpit-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="cockpit-1" name="cockpit-rating" value="1" (change)="valueCockpit = 1" />
							<label for="cockpit-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
					<div *ngIf="accessRequest" class="classification-categories">
						<span>{{ labels.lbl_chamado }}</span>
						<div class="classification-categorie">
							<input type="radio" id="request-5" name="request-rating" value="5" (change)="valueRequest = 5" />
							<label for="request-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="request-4" name="request-rating" value="4" (change)="valueRequest = 4" />
							<label for="request-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="request-3" name="request-rating" value="3" (change)="valueRequest = 3" />
							<label for="request-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="request-2" name="request-rating" value="2" (change)="valueRequest = 2" />
							<label for="request-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="request-1" name="request-rating" value="1" (change)="valueRequest = 1" />
							<label for="request-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
					<div *ngIf="accessReports" class="classification-categories">
						<span>{{ labels.lbl_geral_relatorio }}</span>
						<div class="classification-categorie">
							<input type="radio" id="report-5" name="report-rating" value="5" (change)="valueReport = 5" />
							<label for="report-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="report-4" name="report-rating" value="4" (change)="valueReport = 4" />
							<label for="report-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="report-3" name="report-rating" value="3" (change)="valueReport = 3" />
							<label for="report-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="report-2" name="report-rating" value="2" (change)="valueReport = 2" />
							<label for="report-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="report-1" name="report-rating" value="1" (change)="valueReport = 1" />
							<label for="report-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
					<div *ngIf="accessRegister" class="classification-categories">
						<span>{{ labels.lbl_geral_registrar }}</span>
						<div class="classification-categorie">
							<input type="radio" id="register-5" name="register-rating" value="5" (change)="valueRegister = 5" />
							<label for="register-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="register-4" name="register-rating" value="4" (change)="valueRegister = 4" />
							<label for="register-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="register-3" name="register-rating" value="3" (change)="valueRegister = 3" />
							<label for="register-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="register-2" name="register-rating" value="2" (change)="valueRegister = 2" />
							<label for="register-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="register-1" name="register-rating" value="1" (change)="valueRegister = 1" />
							<label for="register-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
					<div *ngIf="accessStock" class="classification-categories">
						<span>{{ labels.lbl_status_estoque }}</span>
						<div class="classification-categorie">
							<input type="radio" id="stock-5" name="stock-rating" value="5" (change)="valueStock = 5" />
							<label for="stock-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="stock-4" name="stock-rating" value="4" (change)="valueStock = 4" />
							<label for="stock-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="stock-3" name="stock-rating" value="3" (change)="valueStock = 3" />
							<label for="stock-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="stock-2" name="stock-rating" value="2" (change)="valueStock = 2" />
							<label for="stock-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="stock-1" name="stock-rating" value="1" (change)="valueStock = 1" />
							<label for="stock-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
					<div *ngIf="accessKb" class="classification-categories">
						<span>Knowledge</span>
						<div class="classification-categorie">
							<input type="radio" id="knowledge-5" name="knowledge-rating" value="5" (change)="valueKnowledge = 5" />
							<label for="knowledge-5"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="knowledge-4" name="knowledge-rating" value="4" (change)="valueKnowledge = 4" />
							<label for="knowledge-4"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="knowledge-3" name="knowledge-rating" value="3" (change)="valueKnowledge = 3" />
							<label for="knowledge-3"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="knowledge-2" name="knowledge-rating" value="2" (change)="valueKnowledge = 2" />
							<label for="knowledge-2"><fa-icon [icon]="icons.faStar"></fa-icon></label>
							<input type="radio" id="knowledge-1" name="knowledge-rating" value="1" (change)="valueKnowledge = 1" />
							<label for="knowledge-1"><fa-icon [icon]="icons.faStar"></fa-icon></label>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</section>

	<div class="titles">{{ labels.lbl_esta_gostando_do_MySupport }}</div>
	<section class="section-two">
		<div class="icons">
			<label class="like primary-2" (click)="toggleLike('like')" [class.selected]="likeSelected"
				><fa-icon [icon]="icons.faThumbsUp"></fa-icon
			></label>
			<label class="dislike primary-2" (click)="toggleLike('dislike')" [class.selected]="dislikeSelected"
				><fa-icon [icon]="icons.faThumbsDown"></fa-icon
			></label>
		</div>

		<div class="comments-container">
			<div class="comment-header">
				<span>{{ labels.lbl_deixar_comentario }}</span>
				<span class="char-counter">0/512</span>
			</div>
			<textarea
				rows="5"
				maxlength="512"
				placeholder="{{ labels.lbl_comentario_opcional }}"
				(input)="updateCharCount($event)"
				(change)="valueDescription = $event.target.value"></textarea>
		</div>

		<div class="button-container">
			<div class="button primary-2" (click)="saveContent()">{{ labels.lbl_geral_salvar }}</div>
		</div>
	</section>
</div>

<div class="centered" *ngIf="isLoadingLabels || isLoadingEvaluation">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}...</div>
</div>
